import { render, staticRenderFns } from "./vacation.vue?vue&type=template&id=756ddd95&scoped=true&"
import script from "./vacation.vue?vue&type=script&lang=js&"
export * from "./vacation.vue?vue&type=script&lang=js&"
import style0 from "./vacation.vue?vue&type=style&index=0&id=756ddd95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ddd95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756ddd95')) {
      api.createRecord('756ddd95', component.options)
    } else {
      api.reload('756ddd95', component.options)
    }
    module.hot.accept("./vacation.vue?vue&type=template&id=756ddd95&scoped=true&", function () {
      api.rerender('756ddd95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/vacation/vacation.vue"
export default component.exports